import { selectRecallAIManager } from '../selectors/recallAI';
import { useAppSelector } from '../store/store';
export default function useRecallAIManager() {
    const recallAIManager = useAppSelector(selectRecallAIManager);
    return recallAIManager;
}
